<template>
  <div style="width: 100%">
    <img
      :src="require('@/assets/image/question-back.png')"
      style="width: 40px; height: 40px; margin-top: 20px; cursor: pointer"
      @click="backHome"
    />
    <div class="top-step">
      <el-form
        ref="form"
        style="margin-bottom: 0"
        :model="eventsInfo"
        label-position="right"
        label-width="180px"
      >
        <el-form-item label="事项名称：">
          {{ eventsInfo.eventInfo.sxmc }}
        </el-form-item>
        <el-form-item label="任务指标：">
          <div class="index" v-if="eventsInfo.indexList.length">
            <span
              class="index-item"
              v-for="(item, index) in eventsInfo.indexList"
              :key="index"
            >
              <span
                >{{ item.zbmc }}
                <span v-if="eventsInfo.indexList.length - 1 != index">、</span></span
              >
            </span>
          </div>
        </el-form-item>
        <el-form-item label="所属网格：">
          <div class="index" v-if="eventsInfo.returnPointList.length">
            <span
              class="index-item"
              v-for="(item, index) in eventsInfo.returnPointList"
              :key="index"
            >
              <span
                >{{ item.pointName
                }}<span v-if="eventsInfo.returnPointList.length - 1 != index"
                  >、</span
                ></span
              >
            </span>
          </div>
        </el-form-item>
        <el-form-item label="网格每日完成次数：">
          {{ eventsInfo.eventInfo.dayTimes }}
        </el-form-item>
        <el-form-item label="包片科室每周完成次数：">
          {{ eventsInfo.eventInfo.ksWeekTimes }}
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import {
  infiniteEventFullDetail,
  createTempTask,
  createInfiniteTask,
} from "@/api/task.js";
export default {
  props: {
    typeTask: {
      type: Number,
    },
    lookId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      eventsInfo: {
        pointLevelIdList: [],
        selectedIdOptions: [],
        indexList: [],
        eventInfo: {
          sxmc: "",
          dayTimes: 1,
          ksWeekTimes: 1,
          id: "",
        },
      },
    };
  },
  mounted() {
    if (this.lookId) {
      this.lookDialogFun(this.lookId);
    }
  },

  methods: {
    async lookDialogFun(id) {
      let res = await infiniteEventFullDetail({
        eventId: id,
      });
      if (res.data.code == 200) {
        this.eventsInfo = res.data.data;
        this.eventsInfo.pointLevelIdList =
          (res.data.data && res.data.data.pointLevelIdList) || [];
        this.eventsInfo.returnPointList =
          (res.data.data && res.data.data.returnPointList) || [];
      }
    },
    backHome() {
      this.$emit("backDetail");
    },
  },
  watch: {},
};
</script>

<style scoped lang="less">
@import "~@/components/less.less";
.top-step {
  width: 817px;
  padding: 40px 0;
  margin: 0 auto;
  /deep/ .el-form-item {
    margin-bottom: 10px;
    .el-form-item__label {
      color: rgb(146, 151, 156);
    }
    .el-form-item__content {
      color: #494c4f;
    }
  }
}
.bottom-info {
  height: calc(100% - 150px);
  .content {
    height: calc(100% - 54px);
    width: 900px;
    margin: 0 auto;
  }
  .footer {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
}
/deep/.el-step__head.is-success,
/deep/.el-step__head.is-process {
  .is-text {
    width: 36px;
    height: 36px;
    background: #0495ff;
    border: 1px solid #0495ff;
    .el-icon-check:before {
      color: #fff;
    }
    .el-step__icon-inner {
      color: #fff;
    }
  }
}
/deep/.el-step__title.is-success,
/deep/.el-step__title.is-process {
  font-size: 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #494c4f;
}
/deep/.el-step__head.is-wait {
  .is-text {
    width: 36px;
    height: 36px;
    background: #f1f4f6;
    border: 1px solid #f1f4f6;
    .el-step__icon-inner {
      color: #9bb6c9;
    }
  }
}
/deep/.el-step__title.is-wait {
  font-size: 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #86909c;
}
/deep/.el-step__line {
  background: none;
}
/deep/.el-step.is-horizontal .el-step__line {
  top: 18px;
}
/deep/.el-step__line-inner {
  border-style: dashed !important;
  border-color: #dde6ec !important;
  width: 100% !important;
  border-width: 1px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/task/customTask/components/detail.vue